module.exports = __webpack_public_path__ + "img/saxophone3.d6340344.png";